<template>
  <div class="main">
    <Header class="header" />
    <CurrencyNotice />
    <router-view class="router-view scroll-auto" />
    <Footer class="footer" />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import CurrencyNotice from "@/components/CurrencyNotice.vue";

export default {
  name: "App",
  components: {
    Header,
    Footer,
    CurrencyNotice
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.main {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.header {
  flex-shrink: 0;
}

.footer {
  flex-shrink: 0;
  margin-top: auto;
}

.router-view {
  flex-grow: 1;
  overflow-y: auto;
}
</style>
